import { FC, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface Props {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Wraps a formatted number so RTL layout cannot reorder it.
 *
 * THE MOST IMPORTANT RTL DETAIL IN THIS FEATURE. Without bidi isolation,
 * `$412.50` sitting next to Arabic text can render as `412.50$`, and a leading
 * minus can detach from its number entirely — in a column of money figures that
 * is not a cosmetic problem.
 *
 * Uses the native `dir` attribute rather than `direction` in `sx`, because the
 * `@mui/stylis-plugin-rtl` cache rewrites `direction` in RTL. `AdminLayout`
 * already establishes this same workaround for the same reason.
 *
 * `tabular-nums` keeps digits aligned across rows, which is what makes a column
 * of costs scannable.
 */
export const UsageNumber: FC<Props> = observer(({ children, sx }) => (
  <Box
    component="span"
    dir="ltr"
    sx={{
      unicodeBidi: 'isolate',
      fontVariantNumeric: 'tabular-nums',
      display: 'inline-block',
      ...sx,
    }}
  >
    {children}
  </Box>
));
